import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BankoveSpojenie } from '../models';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { ZoPPM } from '../models';
// @ts-ignore
import { ZoppmMojZoznamResponse } from '../models';
/**
 * PortalZiadostiApi - axios parameter creator
 * @export
 */
export const PortalZiadostiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * find single priloha by zoppmId
         * @summary get priloha by zoppmId
         * @param {string} zoppmId 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {string} [responseContentType] 
         * @param {string} [responseContentDisposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForZoppmPortalZiadosti: async (zoppmId: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmId' is not null or undefined
            assertParamExists('fetchContentOfDokumentForZoppmPortalZiadosti', 'zoppmId', zoppmId)
            // verify required parameter 'identifikatorUlozisko' is not null or undefined
            assertParamExists('fetchContentOfDokumentForZoppmPortalZiadosti', 'identifikatorUlozisko', identifikatorUlozisko)
            const localVarPath = `/portal-ziadosti/zoppm/{zoppmId}/prilohy/dokumenty`
                .replace(`{${"zoppmId"}}`, encodeURIComponent(String(zoppmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (identifikatorUlozisko !== undefined) {
                localVarQueryParameter['identifikatorUlozisko'] = identifikatorUlozisko;
            }

            if (verziaUlozisko !== undefined) {
                localVarQueryParameter['verziaUlozisko'] = verziaUlozisko;
            }

            if (responseContentType !== undefined) {
                localVarQueryParameter['responseContentType'] = responseContentType;
            }

            if (responseContentDisposition !== undefined) {
                localVarQueryParameter['responseContentDisposition'] = responseContentDisposition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find zoppm draft by Id
         * @summary get my zoppm
         * @param {string} zoppmKod 
         * @param {string} [casOdoslania] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmByKodPortalZiadosti: async (zoppmKod: string, casOdoslania?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmKod' is not null or undefined
            assertParamExists('getMyZoppmByKodPortalZiadosti', 'zoppmKod', zoppmKod)
            const localVarPath = `/portal-ziadosti/moje-ziadosti/{zoppmKod}`
                .replace(`{${"zoppmKod"}}`, encodeURIComponent(String(zoppmKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (casOdoslania !== undefined) {
                localVarQueryParameter['casOdoslania'] = casOdoslania;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find zoppm draft by kod
         * @summary get my zoppm by kod
         * @param {string} zoppmKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoppmByKodPortalZiadosti: async (zoppmKod: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmKod' is not null or undefined
            assertParamExists('getZoppmByKodPortalZiadosti', 'zoppmKod', zoppmKod)
            const localVarPath = `/portal-ziadosti/zoppm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (zoppmKod !== undefined) {
                localVarQueryParameter['zoppmKod'] = zoppmKod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie prijatej ŽoPPM
         * @param {string} zoppmId ŽoPPM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoppmLikePortalPortalZiadosti: async (zoppmId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoppmId' is not null or undefined
            assertParamExists('getZoppmLikePortalPortalZiadosti', 'zoppmId', zoppmId)
            const localVarPath = `/portal-ziadosti/v2/zoppm/{zoppmId}`
                .replace(`{${"zoppmId"}}`, encodeURIComponent(String(zoppmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektBankSpojPortalZiadosti: async (subjektId: string, bankSpojId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalGetSubjektBankSpojPortalZiadosti', 'subjektId', subjektId)
            // verify required parameter 'bankSpojId' is not null or undefined
            assertParamExists('portalGetSubjektBankSpojPortalZiadosti', 'bankSpojId', bankSpojId)
            const localVarPath = `/portal-ziadosti/subjekty/{subjektId}/bankoveSpojenia/{bankSpojId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)))
                .replace(`{${"bankSpojId"}}`, encodeURIComponent(String(bankSpojId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get ziadost url
         * @summary get ziadost url
         * @param {string} ziadostKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ziadostDetailURLPortalZiadosti: async (ziadostKod: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ziadostKod' is not null or undefined
            assertParamExists('ziadostDetailURLPortalZiadosti', 'ziadostKod', ziadostKod)
            const localVarPath = `/portal-ziadosti/ziadost-detail-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (ziadostKod !== undefined) {
                localVarQueryParameter['ziadostKod'] = ziadostKod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortalZiadostiApi - functional programming interface
 * @export
 */
export const PortalZiadostiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortalZiadostiApiAxiosParamCreator(configuration)
    return {
        /**
         * find single priloha by zoppmId
         * @summary get priloha by zoppmId
         * @param {string} zoppmId 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {string} [responseContentType] 
         * @param {string} [responseContentDisposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchContentOfDokumentForZoppmPortalZiadosti(zoppmId: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchContentOfDokumentForZoppmPortalZiadosti(zoppmId, identifikatorUlozisko, verziaUlozisko, responseContentType, responseContentDisposition, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find zoppm draft by Id
         * @summary get my zoppm
         * @param {string} zoppmKod 
         * @param {string} [casOdoslania] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyZoppmByKodPortalZiadosti(zoppmKod: string, casOdoslania?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmMojZoznamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyZoppmByKodPortalZiadosti(zoppmKod, casOdoslania, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find zoppm draft by kod
         * @summary get my zoppm by kod
         * @param {string} zoppmKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoppmByKodPortalZiadosti(zoppmKod: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoppmMojZoznamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoppmByKodPortalZiadosti(zoppmKod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie prijatej ŽoPPM
         * @param {string} zoppmId ŽoPPM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoppmLikePortalPortalZiadosti(zoppmId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoPPM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoppmLikePortalPortalZiadosti(zoppmId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetSubjektBankSpojPortalZiadosti(subjektId: string, bankSpojId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankoveSpojenie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetSubjektBankSpojPortalZiadosti(subjektId, bankSpojId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get ziadost url
         * @summary get ziadost url
         * @param {string} ziadostKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ziadostDetailURLPortalZiadosti(ziadostKod: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ziadostDetailURLPortalZiadosti(ziadostKod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortalZiadostiApi - factory interface
 * @export
 */
export const PortalZiadostiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortalZiadostiApiFp(configuration)
    return {
        /**
         * find single priloha by zoppmId
         * @summary get priloha by zoppmId
         * @param {string} zoppmId 
         * @param {string} identifikatorUlozisko 
         * @param {string} [verziaUlozisko] 
         * @param {string} [responseContentType] 
         * @param {string} [responseContentDisposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForZoppmPortalZiadosti(zoppmId: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options?: any): AxiosPromise<string> {
            return localVarFp.fetchContentOfDokumentForZoppmPortalZiadosti(zoppmId, identifikatorUlozisko, verziaUlozisko, responseContentType, responseContentDisposition, options).then((request) => request(axios, basePath));
        },
        /**
         * Find zoppm draft by Id
         * @summary get my zoppm
         * @param {string} zoppmKod 
         * @param {string} [casOdoslania] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyZoppmByKodPortalZiadosti(zoppmKod: string, casOdoslania?: string, options?: any): AxiosPromise<ZoppmMojZoznamResponse> {
            return localVarFp.getMyZoppmByKodPortalZiadosti(zoppmKod, casOdoslania, options).then((request) => request(axios, basePath));
        },
        /**
         * Find zoppm draft by kod
         * @summary get my zoppm by kod
         * @param {string} zoppmKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoppmByKodPortalZiadosti(zoppmKod: string, options?: any): AxiosPromise<ZoppmMojZoznamResponse> {
            return localVarFp.getZoppmByKodPortalZiadosti(zoppmKod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie prijatej ŽoPPM
         * @param {string} zoppmId ŽoPPM ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoppmLikePortalPortalZiadosti(zoppmId: string, options?: any): AxiosPromise<ZoPPM> {
            return localVarFp.getZoppmLikePortalPortalZiadosti(zoppmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektBankSpojPortalZiadosti(subjektId: string, bankSpojId: string, options?: any): AxiosPromise<BankoveSpojenie> {
            return localVarFp.portalGetSubjektBankSpojPortalZiadosti(subjektId, bankSpojId, options).then((request) => request(axios, basePath));
        },
        /**
         * get ziadost url
         * @summary get ziadost url
         * @param {string} ziadostKod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ziadostDetailURLPortalZiadosti(ziadostKod: string, options?: any): AxiosPromise<string> {
            return localVarFp.ziadostDetailURLPortalZiadosti(ziadostKod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortalZiadostiApi - object-oriented interface
 * @export
 * @class PortalZiadostiApi
 * @extends {BaseAPI}
 */
export class PortalZiadostiApi extends BaseAPI {
    /**
     * find single priloha by zoppmId
     * @summary get priloha by zoppmId
     * @param {string} zoppmId 
     * @param {string} identifikatorUlozisko 
     * @param {string} [verziaUlozisko] 
     * @param {string} [responseContentType] 
     * @param {string} [responseContentDisposition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalZiadostiApi
     */
    public fetchContentOfDokumentForZoppmPortalZiadosti(zoppmId: string, identifikatorUlozisko: string, verziaUlozisko?: string, responseContentType?: string, responseContentDisposition?: string, options?: AxiosRequestConfig) {
        return PortalZiadostiApiFp(this.configuration).fetchContentOfDokumentForZoppmPortalZiadosti(zoppmId, identifikatorUlozisko, verziaUlozisko, responseContentType, responseContentDisposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find zoppm draft by Id
     * @summary get my zoppm
     * @param {string} zoppmKod 
     * @param {string} [casOdoslania] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalZiadostiApi
     */
    public getMyZoppmByKodPortalZiadosti(zoppmKod: string, casOdoslania?: string, options?: AxiosRequestConfig) {
        return PortalZiadostiApiFp(this.configuration).getMyZoppmByKodPortalZiadosti(zoppmKod, casOdoslania, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find zoppm draft by kod
     * @summary get my zoppm by kod
     * @param {string} zoppmKod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalZiadostiApi
     */
    public getZoppmByKodPortalZiadosti(zoppmKod: string, options?: AxiosRequestConfig) {
        return PortalZiadostiApiFp(this.configuration).getZoppmByKodPortalZiadosti(zoppmKod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie prijatej ŽoPPM
     * @param {string} zoppmId ŽoPPM ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalZiadostiApi
     */
    public getZoppmLikePortalPortalZiadosti(zoppmId: string, options?: AxiosRequestConfig) {
        return PortalZiadostiApiFp(this.configuration).getZoppmLikePortalPortalZiadosti(zoppmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie bankového spojenia subjektu
     * @param {string} subjektId Subjekt ID
     * @param {string} bankSpojId Bankové spojenie ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalZiadostiApi
     */
    public portalGetSubjektBankSpojPortalZiadosti(subjektId: string, bankSpojId: string, options?: AxiosRequestConfig) {
        return PortalZiadostiApiFp(this.configuration).portalGetSubjektBankSpojPortalZiadosti(subjektId, bankSpojId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get ziadost url
     * @summary get ziadost url
     * @param {string} ziadostKod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortalZiadostiApi
     */
    public ziadostDetailURLPortalZiadosti(ziadostKod: string, options?: AxiosRequestConfig) {
        return PortalZiadostiApiFp(this.configuration).ziadostDetailURLPortalZiadosti(ziadostKod, options).then((request) => request(this.axios, this.basePath));
    }
}
